import React from "react";
import { Link } from "react-router-dom";
import { ExternalLink } from "lucide-react";
import { PRODUCTS } from "../data/mock";

export default function Shop() {
  return (
    <div>
      <PageTitle title="Shop" />

      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14">
        <div className="flex flex-wrap items-center justify-between gap-4 mb-10 pb-4 border-b border-slate-100">
          <div className="text-sm text-slate-600">
            Sort by <span className="font-semibold">Default Order</span>
          </div>
          <div className="text-sm text-slate-600">
            Show <span className="font-semibold">12 Products</span>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {PRODUCTS.map((p) => (
            <ProductCard key={p.id} product={p} />
          ))}
        </div>
      </div>
    </div>
  );
}

function ProductCard({ product }) {
  const [hover, setHover] = React.useState(false);
  return (
    <div className="group" onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
      <Link to={`/product/${product.slug}`} className="block relative overflow-hidden rounded-sm bg-[#f4f5f7] aspect-square">
        <img
          src={hover ? product.hoverThumb : product.thumb}
          alt={product.name}
          className="w-full h-full object-contain p-6 transition-transform duration-500 group-hover:scale-105"
        />
      </Link>
      <div className="mt-5">
        <h3 className="text-[17px] font-semibold text-slate-800 leading-snug hover:text-[#29abe2] transition-colors">
          <Link to={`/product/${product.slug}`}>{product.name}</Link>
        </h3>
        <div className="mt-2 text-slate-700 font-semibold">${product.price.toFixed(2)}</div>
        <div className="mt-4 flex gap-3">
          <a
            href={"/product/" + product.slug}
            className="inline-flex items-center gap-2 bg-[#29abe2] hover:bg-[#1f9bd0] text-white text-xs font-semibold tracking-widest uppercase px-5 py-2.5 rounded transition-colors"
          >
            Add to cart
          </a>
          <Link
            to={`/product/${product.slug}`}
            className="inline-flex items-center gap-1 text-xs font-semibold tracking-widest uppercase text-slate-600 hover:text-[#29abe2] px-2 py-2.5"
          >
            Details <ExternalLink className="w-3 h-3" />
          </Link>
        </div>
      </div>
    </div>
  );
}

function PageTitle({ title }) {
  return (
    <section className="bg-[#f4f5f7] py-14 border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <h1 className="text-4xl font-semibold text-slate-800">{title}</h1>
      </div>
    </section>
  );
}
